<template>
  <div class="item-box-content" style="padding-bottom:0px;">
    <el-row>
      <el-col :span="12">
        <div class="title-font-style">
          <span>帐户信息</span>
        </div>
      </el-col>
      <el-col :span="12" style="text-align:right;" v-show="params.state === 4">
        <el-button @click="onRevise" v-show="!isDetail">修 改</el-button>
        <el-button @click="onSubmit" type="primary" v-show="isDetail">提 交</el-button>
      </el-col>
    </el-row>

    <el-form
      label-width="70px"
      :class="isDetail ? '' : 'details-line-height'"
      style="padding:20px 30px 0 30px;"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="账户名称：">
            <span style="margin-right:20px">{{ params.suName }}</span>
            <el-button v-show="isDetail" @click="onAddAccount" type="text" icon="el-icon-plus">添加账户</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="银行账号：">
            <span v-show="!isDetail">{{ params.receiptBankNumber }}</span>
            <el-select v-show="isDetail" v-model="obj.receiptBankNumber" @change="changeSelect">
              <el-option
                v-for="(item,index) in list"
                :key="index"
                :label="item.bankAccount"
                :value="item.bankAccount"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="开户行：">
            <span v-show="!isDetail">{{ params.receiptOpenBank }}</span>
            <el-input v-show="isDetail" v-model="obj.receiptOpenBank" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="银行行号：">
            <span v-show="!isDetail">{{ params.receiptOpenNumber }}</span>
            <el-input v-show="isDetail" v-model="obj.receiptOpenNumber" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!------------ 添加账户 ------------>
    <add-bank-account-dialog ref="addBankAccountDialogRefs" @addAccountDialog="addAccountDialog"></add-bank-account-dialog>
  </div>
</template>
<script>
import addBankAccountDialog from '@/components/AddAccount/addAccountDialog'
import {
  updateReceiptNameByPayNumber,
  queryAllByCusId
} from '@/api/sell/sellManage'
export default {
  components: {
    'add-bank-account-dialog': addBankAccountDialog
  },
  props: ['queryParams'],
  data () {
    return {
      value: '',
      list: [],
      isDetail: false,
      params: {},
      obj: {}
    }
  },
  watch: {
    queryParams: {
      handler (val) {
        this.list = val.customerBankList
        val.cid = val.cusId
        this.params = val
        if (this.$route.name === 'initiateWithdrawal') {
          this.isDetail = true
        }
      },
      deep: true
    }
  },
  methods: {
    changeSelect (id) {
      // 银行账号下拉框
      const obj = this.list.filter((ele) => ele.bankAccount === id)[0]
      this.obj.receiptOpenNumber = obj.bankCode
      this.obj.receiptOpenBank = obj.bankOpencount
      this.obj.receiptOpenBank = obj.bankOpencount
    },
    onSubmit () {
      // 提交
      updateReceiptNameByPayNumber(this.params).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('提现申请已提交，请等待审核！')
          this.$router.push({ name: 'customerWithdrawalRecord' })
          this.isDetail = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onRevise () {
      // 修改
      queryAllByCusId(this.params.cid).then((res) => {
        if (res.data.code === 200) {
          this.isDetail = true
          this.list = res.data.obj
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    addAccountDialog (obj, arr) {
      this.list = arr
      this.obj.receiptOpenNumber = obj.bankCode
      this.obj.receiptBankNumber = obj.bankAccount
      this.obj.receiptOpenBank = obj.bankOpencount
    },
    // 添加账户
    onAddAccount () {
      const obj = {
        suName: this.params.suName,
        cusId: this.params.cid,
        isChange: 85
      }
      this.$refs.addBankAccountDialogRefs.onInitial(obj)
    }
  }
}
</script>
